<script>
import { ValidateRule } from 'dygc'
import { Notify } from 'vant';


export default {
  name: "PhoneValidate",
  props: {
    title: {
      type: String,
      default: ""
    }
  },
  data() {
    return {
      show: false,
      phone: "",
      code: "",
      remainingTime: 0
    }
  },
  computed: {
    getCodeCurrentText() {
      if (this.remainingTime <= 0) {
        return "获取验证码"
      }
      return `${this.remainingTime}秒后重试`
    }
  },
  mounted() {
    this.show = true
  },
  methods: {
    onClose() {
      this.$emit('close')
    },
    onGetCode() {
      if (this.remainingTime > 0) {
        return
      }
      if (!this.phone.trim()) {
        Notify('请输入手机号')
        return
      }
      if (!ValidateRule.phone(this.phone.trim())) {
        Notify('手机号输入有误，请检查')
        return
      }
      this.remainingTime = 60
      let timer = setInterval(() => {
        this.remainingTime = this.remainingTime - 1
        if (!this.remainingTime) {
          clearInterval(timer)
        }
      })

    },
    onConfirm() {
      if (!this.code.trim()) {
        Notify({ type: 'danger', message: '请输入验证码' })
        return
      }
      Promise.all([]).then(() => {
        Notify({ type: 'success', message: '保存成功' })
        this.onClose()
      }).catch(err => {
        Notify(err.message)
        return
      })

    }
  }
}
</script>

<template>
  <van-overlay show z-index="1000" class-name="">
    <van-popup v-model="show" position="bottom"
      :style="{ height: '90%', overflow: 'hidden', 'border-radius': '16px 16px 0 0' }" :close-on-click-overlay="false"
      :lock-scroll="false">
      <div class="h-full flex flex-col">
        <div class="py-3 relative">
          <div class="text-center">
            <span class="text-large">{{ title }}</span>
          </div>
          <div class="absolute" style="top: 12px; right: 12px;">
            <van-icon name="cross" @click="onClose" class="text-large" />
          </div>
        </div>
        <div class="validate-content flex-1 pt-3">
          <div class="tips">
            填入正确的手机号，我们会将优惠券以短信的形式，发送到您的手机中。
          </div>

          <div class="mb-6">
            <div class="mb-3">手机号</div>
            <van-field v-model="phone" placeholder="请输入手机号" size="large" />
          </div>
          <div class="mb-10">
            <div class="mb-3">验证码</div>
            <van-field v-model="code" placeholder="请输入验证码" size="large">
              <template #button>
                <span @click="onGetCode">{{ getCodeCurrentText }}</span>
              </template>
            </van-field>
          </div>

          <div class="mb-6">
            <van-button color="#F92A18" class="w-full" block type="primary" @click="onConfirm">确定</van-button>
          </div>
          <div>
            <van-button class="w-full" block type="default" @click="onClose">取消</van-button>
          </div>
        </div>
      </div>
    </van-popup>
  </van-overlay>
</template>

<style scoped lang="scss">
.validate-content {
  padding: 16px;
}

.tips {
  font-size: 12px;
  color: rgba($color: #000000, $alpha: 0.6);
  letter-spacing: 0;
  line-height: 20px;
}
</style>